import React, { useEffect, useState, forwardRef } from "react";
import Status from "../../../components/common/Status/Status";
import ContactUs from "../../../components/common/Status/ContactUs";
import { formatDate } from "../../../Utils/helper";

const TransactionItem = forwardRef(
  (
    {
      status,
      createdAt,
      transactionsFee,
      receiveAmount,
      tokenAmount,
      bankAccount,
    },
    ref
  ) => {
    const [rawBankAccount, setRawBankAccount] = useState(bankAccount);

    useEffect(() => {
      if (bankAccount !== "null" && bankAccount !== null && bankAccount) {
        let phoneNumber = bankAccount;
        let countryCode = "";

        if (bankAccount.startsWith("+65")) {
          countryCode = "+65 ";
          phoneNumber = bankAccount.replace("+65", "").trim();
        }

        let formattedNumber = phoneNumber;
        if (phoneNumber.length > 4) {
          formattedNumber = `${phoneNumber.slice(0, 4)}-${phoneNumber.slice(
            4
          )}`;
        }

        const finalResult = countryCode
          ? `${countryCode}${formattedNumber}`
          : `+65 ${formattedNumber}`;

        setRawBankAccount(finalResult);
      }
    }, [bankAccount]);

    return (
      <div
        ref={ref}
        className="border-b border-gray-200 pb-2 w-full max-w-[480px] flex flex-col"
      >
        <div className="flex justify-between items-start">
          <div className="flex flex-col gap-[18px] mb-3">
            <p className="text-[16px] xs:text-lg font-medium text-[#253FF6]">
              {parseInt(tokenAmount)} Coins - $
              {transactionsFee > 0
                ? receiveAmount.toFixed(2)
                : (receiveAmount - 0.5).toFixed(2)}
            </p>
            <p className="text-[12px] xs:text-sm font-medium text-[#333333] mt-1">
              {rawBankAccount}
            </p>
            <div className="text-xs font-medium text-[#A0A0A0] text-left">
              {/* {convertToSingaporeTime(createdAt, DATE_FORMATS.TRANSACTION_DISPLAY)} */}
              {formatDate(createdAt)}
            </div>
          </div>

          <div className="text-right flex flex-col items-center justify-center">
            <Status status={status} />
            {status === "unsuccessful" && (
              <ContactUs
                className={"flex flex-row-reverse"}
                linkNavigate="/profile/support/contactUS"
              />
            )}
          </div>
        </div>
      </div>
    );
  }
);

TransactionItem.displayName = "TransactionItem";

export default TransactionItem;
